import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiToastService } from '../services/api-toast.service';

export const API_SUCCESS_MESSAGE = new HttpContextToken<string | null>(() => null);
export const API_ERROR_MESSAGE = new HttpContextToken<string | null>(() => null);
export const API_FEEDBACK_SILENT = new HttpContextToken<boolean>(() => false);

export const apiFeedbackInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isBackendApiRequest(request) || request.context.get(API_FEEDBACK_SILENT)) {
    return next(request);
  }

  const toast = inject(ApiToastService);
  const successMessage = request.context.get(API_SUCCESS_MESSAGE);
  const errorMessage = request.context.get(API_ERROR_MESSAGE);

  return next(request).pipe(
    tap((event) => {
      if (
        event instanceof HttpResponse &&
        successMessage
      ) {
        const copy = describeSuccess(successMessage);
        queueMicrotask(() => toast.success(copy.summary, copy.detail));
      }
    }),
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        queueMicrotask(() => toast.fromHttpError(error, errorMessage ?? undefined));
      }
      return throwError(() => error);
    }),
  );
};

function describeSuccess(explicitMessage: string): { summary: string; detail: string } {
  return { summary: 'Operación completada', detail: explicitMessage };
}

function isBackendApiRequest(request: HttpRequest<unknown>): boolean {
  return request.url === environment.apiUrl || request.url.startsWith(`${environment.apiUrl}/`);
}
